var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tabs)?_c('TabMenu',{attrs:{"model":_vm.tabs}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }